<template>
  <v-card class="px-9 py-8" color="primary darken-1" min-height="300">
    <v-row class="pa-0 ma-0">
      <v-col v-if="formInformationMessage" class="mb-3" cols="12">
        <div style="display: flex: align-items: center">
          <v-icon class="mr-1" size="16">mdi-help-circle-outline</v-icon>
          <span style="font-weight: normal; font-size: 14px; line-height: 18px">
            {{ formInformationMessage }}
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="7">
        <h1 style="font-weight: normal; font-size: 16px; line-height: 20px">
          Selecione o tipo de bacia
        </h1>
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="searchOption"
          :items="searchOptions"
          item-color="accent"
          color="accent"
          hide-details
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col cols="12">
        <h1 style="font-weight: normal; font-size: 16px; line-height: 20px">
          Selecione uma bacia
        </h1>
      </v-col>
      <v-col cols="12">
        <v-form ref="form">
        <v-autocomplete
          v-model="model"
          :items="result"
          :loading="isLoading"
          :search-input.sync="search"
          :rules="listRules"
          no-filter
          item-text="text"
          return-object
          clearable
          outlined
          dense
          placeholder="Digite para Pesquisar"
          item-color="accent"
          color="accent"
        >
          <template v-slot:no-data>
            <v-list-item v-show="!afterSearch">
              <v-list-item-title>
                <span class="error--text">Não encontrado.</span>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-autocomplete>
        </v-form>
      </v-col>
      <div :class="this.$vuetify.breakpoint.name === 'xs' ? 'text-center' : 'mt-6 ml-3'">
        <v-btn
          class="
            button-text
            secondary
            lighten-1
            primary--text
            text--darken
            px-6
            py-4
          "
          height="52"
          style="font-weight: normal; font-size: 16px; line-height: 20px"
          @click="consultData"
          :loading="loading"
          :disabled="loading"
          >
          <span style="color: #212a35;">Consultar</span>
        </v-btn>
      </div>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "RainEstimationHistoricalDataForm",
  props: {
    searchResult: {
      type: Object,
    },
    formInformationMessage: { type: String, required: false },
  },
  data: () => ({
    searchOption: null,
    searchOptions: ["Bacia de manancial", "Bacia receptora de efluentes"],
    result: [],
    isLoading: false,
    search: "",
    model: null,
    listRules: [v => !!v || 'Você precisa selecionar uma bacia para fazer a consulta.'],
    afterSearch: false,
    loading: false,
  }),
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      let obj = await this.$route.params
      this.searchOption = "Bacia de manancial";
      //this.result = this.fountains
      if (obj.previus === 'Effluents') {
        this.searchOption = "Bacia receptora de efluentes";
        //this.result = this.receivingBodies
      }
      await this.$store.dispatch("loadFountains", {
        basin_id: 16,
        customer_id: 7,
      });
      await this.$store.dispatch("loadReceivingBodies", {
        basin_id: 17,
        customer_id: 7,
      });
      if(obj.previus === 'Monitoring'){
        this.model = this.fountains.find((item) => {
          return item.locationid === Number(obj.locationid);
        });
        this.result.push(this.model);
      } else if(obj.previus === 'Effluents') {
        this.model = this.receivingBodies.find((item) => {
          return item.locationid === Number(obj.locationid);
        });
        this.result.push(this.model);
      }
    },
    slugify(str) {
      str = str.toLowerCase();
      var from = "Ã Ã¡Ã£Ã¤Ã¢Ã¨Ã©Ã«ÃªÃ¬Ã­Ã¯Ã®Ã²Ã³ÃµÃ¶Ã´Ã¹ÃºÃ¼Ã»Ã§";
      var to = "aaaaaeeeeiiiiooooouuuuc";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }
      return str;
    },
    checkEquality(val) {
      val = this.slugify(val);
      this.result = [];
      if (this.searchOption === "Bacia de manancial") {
        this.result = this.fountains.filter((item) => {
          if (item.slug.includes(val)) {
            return item;
          }
        });
      } else if (this.searchOption === "Bacia receptora de efluentes") {
        this.result = this.receivingBodies.filter((item) => {
          if (item.slug.includes(val)) {
            return item;
          }
        });
      }
      if (this.result.length === 0) {
        this.afterSearch = false;
      } else {
        this.afterSearch = true;
      }
      this.isLoading = false;
    },

    consultData() {
      if( this.$refs.form.validate() ){
        this.loading = true
        this.$emit("searchBasinData",  { location: this.model } );
        setTimeout(() => { this.loading = false }, 3000)
      }
    },

  },
  computed: {
    fountains() {
      let fountains = this.$store.getters.fountains;
      let aux = [];
      for (let fountain in fountains) {
        let slug = this.slugify(fountains[fountain].locationname);
        let holder = {
          text: fountains[fountain].locationname,
          locationid: fountains[fountain].locationid,
          customid: fountains[fountain].customid,
          slug: slug,
        };
        aux.push(holder);
      }
      return aux;
    },
    receivingBodies() {
      let receivingBodies = this.$store.getters.receivingBodies;
      let aux = [];
      for (let cr in receivingBodies) {
        let slug = this.slugify(receivingBodies[cr].locationname);
        let holder = {
          text: receivingBodies[cr].locationname,
          locationid: receivingBodies[cr].locationid,
          customid: receivingBodies[cr].customid,
          slug: slug,
        };
        aux.push(holder);
      }
      return aux;
    },
  },
  watch: {
    searchOption() {
      this.model = null;
      this.result = [];
    },
    search(val) {
      if (val) {
        if (val.length >= 2) {
          this.isLoading = true;
          setTimeout(() => {
            this.checkEquality(val);
          }, 2000);
        }
      }
    },
    searchResult(value) {
      if(value) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
